import { Controller } from '@hotwired/stimulus'

// Shows/hides the per-school referral-contact section live as the org's
// "Auto-approve referrals" checkbox is toggled, so it appears or disappears
// immediately without requiring a save.
//
// alwaysVisible pins the section open for orgs where referrals can be approved on
// the school's behalf after a review period, making the contact relevant even with
// immediate auto-approval switched off.
export default class extends Controller {
  static values = { alwaysVisible: Boolean }

  connect() {
    if (this.alwaysVisibleValue) {
      this.element.classList.remove('hidden')
      return
    }

    this.checkbox = document.getElementById('organization_auto_approve_referrals')
    if (!this.checkbox) return

    this.sync = this.sync.bind(this)
    this.checkbox.addEventListener('change', this.sync)
    this.sync()
  }

  disconnect() {
    this.checkbox?.removeEventListener('change', this.sync)
  }

  sync() {
    this.element.classList.toggle('hidden', !this.checkbox.checked)
  }
}
